import {
    Box,
    Button,
    Checkbox,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControlLabel,
    IconButton,
    InputAdornment,
    Paper,
    Stack,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import Header from '../../components/navigation/Header';
import { makeStyles } from '@mui/styles';
import KenTable from '../../components/KenTable';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import { useLocation, useNavigate } from 'react-router-dom';
import { getQuestionPaper, postUpdateEvaluation } from '../../utils/apiService';
import { useSnackbar } from '../../components/KenSnackbar';
import { useLoader } from '../../components/KenLoader';

const useStyles = makeStyles(() => ({
    header: {
        fontSize: '18px !important',
        fontWeight: '500 !important',
    },
    container: {
        borderRadius: '8px',
        marginTop: '32px',
        height: 'calc(100vh - 165px)',
        position: 'relative',
        overflow: 'auto',
        background: '#FFF',
    },
    tabRoot: {
        textTransform: 'capitalize', // make labels capitalized
        fontSize: '16px',
        fontWeight: 500,
    },
    RightChip: {
        fontSize: '14px !important',
        background: '#E8EBF3',
        padding: '6px 8px',
        borderRadius: '100px',
    },
    subHeader: {
        fontSize: '20px !important',
        color: '#373A45 !important',
        fontWeight: '500 !important',
    },
}));

interface QuestionRow {
    id: number;
    question: string;
    maxMarks: number;
    include: boolean;
    marks: number | '';
}

interface QuestionRow1 {
    id: number;
    question: string;
    maxMarks: number;
    marks: number | '';
    error?: string;
}

const parseMarksInput = (value: string): number | '' | null => {
    if (value.trim() === '') {
        return '';
    }

    const parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
};

const EvaluationDetails = () => {
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [data, setData] = useState<any>([]);
    const [totalMarks, setTotalMarks] = useState<number>(0);
    const [marksObtained, setMarksObtained] = useState<number>(0);
    const [overallResponse, setOverallResponse] = useState<any>(null);
    const { state } = useLocation();
    const locationData = state.data
    const { showSnackbar } = useSnackbar();
    const { showLoader, hideLoader } = useLoader();
    const navigate = useNavigate();


    console.log("Received data:", state);
    useEffect(() => {
        showLoader();

        let payload = state?.rowData?.examConnectionRecordId;
        getQuestionPaper(payload).then((res) => {
            hideLoader()

            console.log(state, "questioadan adadapaper data");
            let response = res?.data;


            if (locationData?.rowData?.EvaluationStatus === "Pending" || null) {
                var questionPaperObj = JSON.parse(response?.questionPaper?.jsonFormat);
                setData(questionPaperObj?.question_paper_parts.reverse())
            } else {
                var questionPaperObj = JSON.parse(response?.componentScore?.jsonFormat);
                setData(questionPaperObj?.question_paper_parts)

            }

            console.log(questionPaperObj, "kndkndv");
            setOverallResponse(questionPaperObj);


            const totalMarks = questionPaperObj?.question_paper_parts.reduce((sum: any, student: any) => sum + student.max_marks, 0);
            console.log(totalMarks, "dsbdhjbv");
            setTotalMarks(totalMarks);

            console.log(questionPaperObj?.question_paper_parts, "question paper arraya");


        }).catch((err) => {
            hideLoader()
            console.log(err);
        })
    }, []);
    useEffect(() => {
        if (!data || data.length === 0) return;

        // Sum all entered or existing marks from sub-questions
        const total = data.reduce((totalSum: number, part: any) => {
            const partSum = part.question_paper_questions?.reduce((qSum: number, q: any) => {
                const subSum = q.question_paper_sub_questions?.reduce(
                    (sSum: number, sub: any) => sSum + (parseFloat(sub.score) || 0),
                    0
                );
                return qSum + subSum;
            }, 0);
            return totalSum + (partSum || 0);
        }, 0);

        setMarksObtained(total);
    }, [data]);


    const handleSave = (type: string) => {
        showLoader();


        setOverallResponse((prev: any) => {
            const updatedQuestionPaper = {
                ...prev,
                question_paper_parts: data,
            };
            console.log(updatedQuestionPaper, "final question paper");
            return updatedQuestionPaper;
        });

        const payloadUpdatedQuestionPaper = JSON.stringify(overallResponse);
        console.log(payloadUpdatedQuestionPaper, "dsmfbsdbf");

        console.log(locationData?.data, "sdjsasdsadsa");
        let contactId = localStorage.getItem("contactId")

        let payload = {
            "contact_id": contactId,
            "Exam_Format__c": locationData?.data?.ExamFormat,  // pass
            "Course_Code__c": locationData?.data?.courseCode,  //pass
            "Exam_Type__c": locationData?.data?.ExamType,  //pass
            "Evaluator_Type__c": locationData?.data?.evaluationType, //pass
            "Evaluation_JSON__c": payloadUpdatedQuestionPaper,
            "Evaluation_Status__c": type === "submit" ? "Completed" : "Partially evaluated",
            "Component Scores Id": null,
            "Sub Component Scores Id": null,
            "ExamID": state?.rowData?.examid,  //pass
            "Exam Connection ID": state?.rowData?.examConnectisonRecordId, // pass
            "Sub_Component_Marks_Obtained": marksObtained
        }
        console.log('Payload ready for submission:', payload);
        console.log(payload, "savingData");

        postUpdateEvaluation(payload).then((res) => {
            showSnackbar("Evaluation updated successfully.", "success");
            hideLoader()
            navigate('-1')

        }).catch((err) => {
            showSnackbar("Failed to update evaluation. Please try again.", "error");
            hideLoader()
        })

    }

    const [rows1, setRows1] = useState<QuestionRow1[]>([
        {
            id: 1,
            question:
                'State and explain the principle of duality in electrical networks. Give an example of a dual network.',
            maxMarks: 15,
            marks: '',
        },
        {
            id: 2,
            question:
                'Determine the driving point impedance of a two-port network represented by the following T-network: (give component values). Show the steps clearly.',
            maxMarks: 10,
            marks: '',
        },
        {
            id: 3,
            question:
                "What are Foster's forms of network synthesis? Derive Foster's first form for realizing a given impedance function.",
            maxMarks: 5,
            marks: '',
        },
        {
            id: 4,
            question:
                'Explain the conditions for a function to be a positive real function (PRF). Why is this property essential in network synthesis?',
            maxMarks: 5,
            marks: '',
        },
    ]);

    const [rows, setRows] = useState<QuestionRow[]>([
        {
            id: 1,
            question:
                'State and explain the principle of duality in electrical networks. Give an example of a dual network.',
            maxMarks: 10,
            include: true,
            marks: 8,
        },
        {
            id: 2,
            question:
                'Determine the driving point impedance of a two-port network represented by the following T-network: (give component values). Show the steps clearly.',
            maxMarks: 2,
            include: true,
            marks: '',
        },
        {
            id: 3,
            question:
                "What are Foster's forms of network synthesis? Derive Foster's first form for realizing a given impedance function.",
            maxMarks: 2,
            include: false,
            marks: '',
        },
    ]);

    const [isSummaryOpen, setSummaryOpen] = useState(false);

    const handleMarksChange1 = (id: any, value: string) => {
        console.log(id, value, "→ handleMarksChange1 called");

        const parsed: any = parseMarksInput(value);

        setData((prev: any) =>
            prev.map((row: any) => {

                console.log(row.id, id.mainId, id?.subId, "fndssdsnf");

                if (row.id === id?.mainId) {

                    console.log(row?.question_paper_questions, "adasacssdsdf");
                    // return row;
                }// skip other rows

                if (row?.id === id.mainId) {
                    row.question_paper_questions.map((item: any, index: number) => {

                        console.log(id?.subId, item?.subId, "djfnasdasdsfnds");

                        if (item?.id === id?.partId) {
                            item?.question_paper_sub_questions.map((subItem: any, subIndex: number) => {

                                console.log(subItem?.id, id?.subId, "sdsdsdsdsdsds");
                                if (subItem?.id === id?.subId) {
                                    // Handle empty input — clear marks & error
                                    // if (value === '') {
                                    //     subItem.marks = '';
                                    //     subItem.error = undefined;
                                    //     console.log(subItem, "subItem if");
                                    //     return subItem;
                                    // }
                                    // Invalid input (parse failed)
                                    if (parsed === null || isNaN(parsed)) {
                                        subItem.error = 'Invalid input';
                                        console.log(subItem, "subItem invalid");
                                        return subItem;
                                    }
                                    // Marks greater than max
                                    if (parsed > subItem.max_marks) {
                                        subItem.error = `Entered marks cannot exceed maximum (${subItem.max_marks})`;
                                        console.log(subItem, "subItem max marks");
                                        return subItem;
                                    }
                                    // All good
                                    subItem.score = parsed;
                                    subItem.error = undefined;
                                    console.log(subItem, "subItem all good");
                                    return subItem;
                                }
                            });//subItem loop
                        }
                    })
                    console.log(row, "sdnsdkf");

                }

                if (row.id !== id?.mainId) return row; // skip other rows

                // console.log(row);

                // Handle empty input — clear marks & error

                if (value === '') {
                    return { ...row, marks: '', error: undefined };
                }

                // Invalid input (parse failed)
                if (parsed === null || isNaN(parsed)) {
                    return { ...row, error: 'Invalid input' };
                }

                // Marks greater than max
                if (parsed > row.maxMarks) {
                    return {
                        ...row,
                        error: `Entered marks cannot exceed maximum (${row.maxMarks})`,
                    };
                }

                // All good
                return { ...row, marks: parsed, error: undefined };

            })
        );

        console.log(data, "jndkjndjgnv");

    };


    const handleIncludeChange = (id: number) => {
        setRows((prev) =>
            prev.map((row) =>
                row.id === id
                    ? { ...row, include: !row.include, marks: row.include ? '' : row.marks }
                    : row
            )
        );
    };

    const handleMarksChange = (id: number, value: string) => {
        const parsed = parseMarksInput(value);
        if (parsed === null) {
            return;
        }

        setRows((prev) =>
            prev.map((row) =>
                row.id === id ? { ...row, marks: parsed } : row
            )
        );
    };

    const sectionASummary = useMemo(() => {
        const includedRows = rows.filter((row) => row.include);
        const max = includedRows.reduce((sum, row) => sum + row.maxMarks, 0);
        const obtained = includedRows.reduce(
            (sum, row) => sum + (typeof row.marks === 'number' ? row.marks : 0),
            0
        );
        const missing = includedRows
            .filter((row) => row.marks === '')
            .map((row) => `Q${row.id}`);

        return {
            label: 'Section A',
            description: 'All questions will be counted',
            max,
            obtained,
            missing,
        };
    }, [rows]);

    const sectionBSummary = useMemo(() => {
        const max = rows1.reduce((sum, row) => sum + row.maxMarks, 0);
        const obtained = rows1.reduce(
            (sum, row) => sum + (typeof row.marks === 'number' ? row.marks : 0),
            0
        );
        const missing = rows1
            .filter((row) => row.marks === '')
            .map((row) => `Q${row.id}`);

        return {
            label: 'Section B',
            description: 'All questions will be counted',
            max,
            obtained,
            missing,
        };
    }, [rows1]);

    const totalObtained = sectionASummary.obtained + sectionBSummary.obtained;
    const totalMax = sectionASummary.max + sectionBSummary.max;

    const missingSections = [
        sectionASummary.missing.length
            ? `${sectionASummary.label}: ${sectionASummary.missing.join(', ')}`
            : null,
        sectionBSummary.missing.length
            ? `${sectionBSummary.label}: ${sectionBSummary.missing.join(', ')}`
            : null,
    ].filter(Boolean) as string[];

    const handleOpenSummary = () => {
        setSummaryOpen(true);
    };

    const handleCloseSummary = () => {
        setSummaryOpen(false);
    };




    const columns: any = [
        {
            field: 'id',
            headerName: 'Question no.',
        },
        {
            field: 'question',
            headerName: 'Question',
        },
        {
            field: 'maxMarks',
            headerName: 'Maximum marks',
        },
        {
            field: 'include',
            headerName: 'Include',
            renderCell: ({ row }: { row: QuestionRow }) => (
                <Checkbox
                    checked={row.include}
                    onChange={() => handleIncludeChange(row.id)}
                />
            ),
        },
        {
            field: 'marks',
            headerName: 'Enter marks',
            renderCell: ({ row }: { row: QuestionRow }) => (
                <TextField
                    variant="outlined"
                    size="small"
                    type="number"
                    value={row.marks}
                    onChange={(e) => handleMarksChange(row.id, e.target.value)}
                    disabled={!row.include}
                    sx={{ width: 80 }}
                    inputProps={{ style: { textAlign: 'center' } }}
                />
            ),
        },
    ];

    const columns1: any = [
        {
            field: 'id',
            headerName: 'Question no.',
        },
        {
            field: 'question',
            headerName: 'Question',
        },
        {
            field: 'marks',
            headerName: 'Marks',
            renderCell: ({ row }: any) => (
                <Box display="flex" alignItems="center" gap={1}>
                    <TextField
                        variant="outlined"
                        size="small"
                        value={row.marks}
                        onChange={(e) => handleMarksChange1(row.id, e.target.value)}
                        sx={{ width: 60 }}
                        inputProps={{
                            style: { textAlign: 'center' },
                        }}
                        error={!!row.error}
                    />
                    <Typography variant="body2">/{row.maxMarks}</Typography>
                    {row.error && (
                        <ErrorOutlineIcon color="error" fontSize="small" />
                    )}
                    {row.error && (
                        <Typography variant="caption" color="error">
                            {row.error}
                        </Typography>
                    )}
                </Box>
            ),
        },
    ];
    const columnsX = [
        {
            field: "sub_question_name",
            headerName: (rows: any) => {
                console.log(rows, "rows in header");
                const totalMaxMarks = rows.reduce((sum: any, item: any) => sum + (item.maxMarks || 0), 0);
                return <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="subtitle2">{`Question ${rows[0].row}`} {' '}{(`(${totalMaxMarks} marks)`)}</Typography>
                </Box>
            },
            renderCell: ({ row }: any) => <Typography>{row.sub_question_name}</Typography>,
        },
        {
            field: 'question',
            headerName: '',
        },
        {
            field: 'marks',
            headerName: 'Enter marks',
            renderCell: ({ row }: any) => {
                console.log(row, "sdjfdskj");

                return <Box display="flex" alignItems="center" gap={1}>
                    <TextField
                        variant="outlined"
                        size="small"
                        value={row.marks}
                        // disabled={!isSelected}
                        onChange={(e) => {
                            handleMarksChange1(row, e.target.value);
                        }}
                        sx={{ width: 60 }}
                        inputProps={{
                            style: { textAlign: 'center' },
                        }}
                        error={!!row.error}
                    />
                    <Typography variant="body2">/{row.maxMarks}</Typography>
                    {row.error && (
                        <ErrorOutlineIcon color="error" fontSize="small" />
                    )}
                    {row.error && (
                        <Typography variant="caption" color="error">
                            {row.error}
                        </Typography>
                    )}
                </Box>
            },
        },
    ];


    const [selectedOptionalTables, setSelectedOptionalTables] = useState<number[]>([]);

    return (
        <Box>
            <Header title={state?.data?.data?.title} />
            <Box
                component={Paper}
                className={classes.container}
                sx={{
                    p: isMobile ? 2 : 3,
                    mt: isMobile ? 2 : '32px',
                    backgroundColor: isMobile ? 'transparent' : '#FFF',
                    boxShadow: isMobile ? 'none' : undefined,
                    height: isMobile ? 'auto' : 'calc(100vh - 165px)',
                    overflow: isMobile ? 'visible' : 'auto',
                }}
            >
                {isMobile ? (
                    <Stack spacing={3}>
                        <Stack spacing={1}>
                            <Typography className={classes.header}>#BF389DY92</Typography>
                            <Chip
                                label={`Total marks: ${totalObtained}/${totalMax}`}
                                sx={{ alignSelf: 'flex-start', background: '#373A45', color: 'white' }}
                            />
                        </Stack>

                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                borderRadius: 2,
                                background: '#F6F3FF',
                                border: '1px solid #E8E3FF',
                            }}
                        >
                            <Typography fontWeight={600} mb={1.5}>
                                Evaluation summary
                            </Typography>
                            <Stack spacing={1.5}>
                                <Box display="flex" justifyContent="space-between">
                                    <Box>
                                        <Typography fontWeight={600}>{sectionASummary.label}</Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {sectionASummary.description}
                                        </Typography>
                                    </Box>
                                    <Typography fontWeight={600}>
                                        {sectionASummary.obtained}/{sectionASummary.max}
                                    </Typography>
                                </Box>
                                <Box display="flex" justifyContent="space-between">
                                    <Box>
                                        <Typography fontWeight={600}>{sectionBSummary.label}</Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {sectionBSummary.description}
                                        </Typography>
                                    </Box>
                                    <Typography fontWeight={600}>
                                        {sectionBSummary.obtained}/{sectionBSummary.max}
                                    </Typography>
                                </Box>
                            </Stack>
                            <Divider sx={{ my: 2 }} />
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Typography fontWeight={600}>Total</Typography>
                                <Typography fontWeight={600}>
                                    {marksObtained}/{totalMarks}
                                </Typography>
                            </Box>
                            {missingSections.length > 0 && (
                                <Box
                                    mt={2}
                                    sx={{
                                        background: '#FFFFFF',
                                        borderRadius: 2,
                                        border: '1px solid #E4E7EC',
                                        p: 1.5,
                                    }}
                                >
                                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                                        <ErrorOutlineIcon color="warning" fontSize="small" />
                                        <Typography fontWeight={600}>Attention!</Typography>
                                    </Box>
                                    <Typography variant="body2" color="text.secondary">
                                        Please verify the marks entered against each section before you save.
                                    </Typography>
                                    <Stack spacing={0.5} mt={1}>
                                        {missingSections.map((item) => (
                                            <Typography key={item} variant="body2" color="text.secondary">
                                                {item}
                                            </Typography>
                                        ))}
                                    </Stack>
                                </Box>
                            )}
                        </Paper>

                        <Stack spacing={1.5}>
                            <Box>
                                <Typography className={classes.subHeader}>
                                    Section A (Total marks: {sectionASummary.max})
                                </Typography>
                                <Typography sx={{ fontSize: '14px' }}>All questions will be counted</Typography>
                            </Box>
                            <Stack spacing={1.5}>
                                {rows.map((row) => (
                                    <Paper
                                        key={row.id}
                                        elevation={0}
                                        sx={{
                                            p: 2,
                                            borderRadius: 2,
                                            border: '1px solid #E4E7EC',
                                            boxShadow: 'none',
                                        }}
                                    >
                                        <Stack spacing={1.5}>
                                            <Box display="flex" justifyContent="space-between" gap={2}>
                                                <Box flex={1}>
                                                    <Typography variant="caption" color="text.secondary">
                                                        Question {row.id}
                                                    </Typography>
                                                    <Typography variant="body2" mt={0.5}>
                                                        {row.question}
                                                    </Typography>
                                                </Box>
                                                <Stack spacing={0.5} alignItems="flex-end">
                                                    <Typography variant="caption" color="text.secondary">
                                                        Max {row.maxMarks}
                                                    </Typography>
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        type="number"
                                                        value={row.marks}
                                                        onChange={(e) => handleMarksChange(row.id, e.target.value)}
                                                        disabled={!row.include}
                                                        sx={{ width: 80 }}
                                                        inputProps={{ style: { textAlign: 'center' } }}
                                                    />
                                                </Stack>
                                            </Box>
                                            <FormControlLabel
                                                sx={{ m: 0 }}
                                                control={
                                                    <Checkbox
                                                        size="small"
                                                        checked={row.include}
                                                        onChange={() => handleIncludeChange(row.id)}
                                                    />
                                                }
                                                label="Include this question"
                                            />
                                        </Stack>
                                    </Paper>
                                ))}
                            </Stack>
                            <Box
                                sx={{
                                    background: '#FFEDC2',
                                    borderRadius: 2,
                                    px: 2,
                                    py: 1.5,
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}
                            >
                                <Typography fontWeight={600}>Section total</Typography>
                                <Typography fontWeight={600}>
                                    {sectionASummary.obtained}/{sectionASummary.max}
                                </Typography>
                            </Box>
                        </Stack>

                        <Stack spacing={1.5}>
                            <Box>
                                <Typography className={classes.subHeader}>
                                    Section B (Total marks: {sectionBSummary.max})
                                </Typography>
                                <Typography sx={{ fontSize: '14px' }}>All questions will be counted</Typography>
                            </Box>
                            <Stack spacing={1.5}>
                                {rows1.map((row) => (
                                    <Paper
                                        key={row.id}
                                        elevation={0}
                                        sx={{
                                            p: 2,
                                            borderRadius: 2,
                                            border: '1px solid #E4E7EC',
                                            boxShadow: 'none',
                                        }}
                                    >
                                        <Stack spacing={1}>
                                            <Box display="flex" justifyContent="space-between" gap={2}>
                                                <Box flex={1}>
                                                    <Typography variant="caption" color="text.secondary">
                                                        Question {row.id}
                                                    </Typography>
                                                    <Typography variant="body2" mt={0.5}>
                                                        {row.question}
                                                    </Typography>
                                                </Box>
                                                <Box display="flex" alignItems="center" gap={1}>
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        type="number"
                                                        value={row.marks}
                                                        onChange={(e) => handleMarksChange1(row.id, e.target.value)}
                                                        sx={{ width: 72 }}
                                                        inputProps={{ style: { textAlign: 'center' } }}
                                                        error={!!row.error}
                                                    />
                                                    <Typography variant="body2">/{row.maxMarks}</Typography>
                                                </Box>
                                            </Box>
                                            {row.error && (
                                                <Typography variant="caption" color="error">
                                                    {row.error}
                                                </Typography>
                                            )}
                                        </Stack>
                                    </Paper>
                                ))}
                            </Stack>
                            <Box
                                sx={{
                                    background: '#FFEDC2',
                                    borderRadius: 2,
                                    px: 2,
                                    py: 1.5,
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}
                            >
                                <Typography fontWeight={600}>Section total</Typography>
                                <Typography fontWeight={600}>
                                    {sectionBSummary.obtained}/{sectionBSummary.max}
                                </Typography>
                            </Box>
                        </Stack>

                        <Divider />
                        <Stack spacing={1.5}>
                            <Typography variant="body2" color="text.secondary">
                                Last saved at 08:30pm
                            </Typography>
                            <Button variant="text" fullWidth>
                                Save
                            </Button>
                            <Button variant="secondary" fullWidth onClick={handleOpenSummary}>
                                Save & Next
                            </Button>
                        </Stack>
                    </Stack>
                ) : (
                    <>
                        <Box
                            className="d-flex justify-content-between align-items-center"
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: 2,
                            }}
                        >
                            <Typography className={classes.header}>#{state?.data?.data?.bundleCode}</Typography>
                            <Box className="d-flex gap-3 align-items-center" sx={{ display: 'flex', gap: 3 }}>
                                <Chip
                                    label={`Total marks: ${marksObtained}/${totalMarks}`}
                                    sx={{ background: '#373A45', color: 'white' }}
                                />
                                <Button>{`< Previous`}</Button>
                                <Button onClick={handleOpenSummary}>{`Save & Next >`}</Button>
                            </Box>
                        </Box>

                        <Divider className="mt-2" />
                        {data?.map((item: any, index: number) => {
                            const text: any = item?.instructions;
                            const matches = text?.match(/\d+/g);
                            const importantQuestions = matches ? matches.map(Number) : [];
                            const requiredQuestios = importantQuestions.length;
                            const questions_to_be_answered = item?.questions_to_be_answered;

                            // Sort the questions
                            item?.question_paper_questions.sort((a: any, b: any) => {
                                const aIndex = importantQuestions.indexOf(a.question_number);
                                const bIndex = importantQuestions.indexOf(b.question_number);

                                if (aIndex === -1 && bIndex === -1) {
                                    return a.question_number - b.question_number;
                                }
                                if (aIndex === -1) return 1;
                                if (bIndex === -1) return -1;
                                return aIndex - bIndex;
                            });

                            // Split and tag optional ones
                            const importantSet = item.question_paper_questions.slice(0, requiredQuestios);
                            const remainingSet = item.question_paper_questions.slice(requiredQuestios);
                            const updatedRemainingSet = remainingSet.map((q: any) => ({
                                ...q,
                                optional: `any ${requiredQuestios} of ${remainingSet.length}`,
                                requiredAns: requiredQuestios,
                            }));

                            const finalQuestionsToAnswer = [...importantSet, ...updatedRemainingSet];
                            const mainId = item?.id;

                            return (
                                <Box key={index}>
                                    {/* Section Header */}
                                    <Box className="mt-4">
                                        <Typography className={classes.subHeader}>
                                            Part {item?.part} (Total marks: {item?.max_marks})
                                        </Typography>
                                        <Typography sx={{ fontSize: "14px" }}>{item?.instructions}</Typography>
                                    </Box>

                                    {/* Render each question */}
                                    {finalQuestionsToAnswer?.map((qItem: any, qIndex: number) => {
                                        // const isOptional = !!qItem?.optional;
                                        // const isChecked = selectedOptionalTables.includes(qIndex);

                                        // const handleCheckboxChange = (checked: boolean) => {
                                        //     setSelectedOptionalTables((prev) => {
                                        //         if (checked) {
                                        //             if (prev.length < requiredQuestios) {
                                        //                 return [...prev, qIndex];
                                        //             }
                                        //             return prev;
                                        //         } else {
                                        //             return prev.filter((i) => i !== qIndex);
                                        //         }
                                        //     });
                                        // };

                                        const question_numbers = qItem?.question_number;
                                        const question_paper_questions = {
                                            ...qItem,
                                            typeOfIt: qIndex === requiredQuestios ? true : false,
                                        };
                                        const partId = question_paper_questions?.id;

                                        // Sort and map sub-questions
                                        const rows =
                                            question_paper_questions?.question_paper_sub_questions
                                                ?.slice()
                                                ?.sort((a: any, b: any) => {
                                                    const [numA, charA] = a.sub_question_name
                                                        .match(/(\d+)([a-zA-Z]?)/)
                                                        .slice(1);
                                                    const [numB, charB] = b.sub_question_name
                                                        .match(/(\d+)([a-zA-Z]?)/)
                                                        .slice(1);

                                                    const numCompare = parseInt(numA) - parseInt(numB);
                                                    if (numCompare !== 0) return numCompare;
                                                    return (charA || "").localeCompare(charB || "");
                                                })
                                                ?.map((q: any, subIndex: number) => ({
                                                    id: subIndex + 1,
                                                    questionId: q?.question_paper_id,
                                                    question_number: q?.question_number,
                                                    question: q?.description,
                                                    maxMarks: q?.max_marks,
                                                    marks: q?.score,
                                                    sub_question_name: q?.sub_question_name,
                                                    row: question_numbers,
                                                    mainId: mainId,
                                                    subId: q?.id,
                                                    partId: partId,
                                                    error: "",
                                                })) || [];

                                        return (
                                            <Box key={qIndex} className="mt-4">
                                                {/* Optional Label + Checkbox */}

                                                {
                                                    question_paper_questions?.typeOfIt && <>  {requiredQuestios !== 0 &&
                                                        qItem?.optional ? <Typography sx={{ fontSize: '14px', fontStyle: 'italic' }} className="mb-2">({qItem?.optional})</Typography> : null
                                                    }</>
                                                }

                                                {/* <>
                                                    {isOptional && (
                                                        <Box display="flex" alignItems="center" mb={1}>
                                                            <Checkbox
                                                                checked={isChecked}
                                                                disabled={
                                                                    !isChecked && selectedOptionalTables.length >= requiredQuestios
                                                                }
                                                                onChange={(e) => handleCheckboxChange(e.target.checked)}
                                                            />

                                                        </Box>
                                                    )}
                                                </> */}
                                                <KenTable
                                                    border={true}
                                                    columns={columnsX}
                                                    rows={rows}
                                                // showCheckbox={true}
                                                />



                                            </Box>
                                        );
                                    })}
                                </Box>
                            );
                        })}


                        {/* <Box className="mt-4">
                            <Typography className={classes.subHeader}>Section A (Total marks: 30)</Typography>
                            <Typography sx={{ fontSize: '14px' }}>All questions will be counted</Typography>
                        </Box>
                        <Box className="mt-4">
                            <KenTable
                                border={true}
                                columns={columns}
                                rows={rows}
                                showCheckbox={false} // we don't want extra left-side checkbox
                            />
                        </Box>
                        <Box className="mt-4">
                            <Typography className={classes.subHeader}>Section B (Total marks: 30)</Typography>
                            <Typography sx={{ fontSize: '14px' }}>All questions will be counted</Typography>
                        </Box>
                        <Box className="mt-4">
                            <KenTable border={true} columns={columns1} rows={rows1} showCheckbox={false} />
                        </Box> */}
                        <Divider className="mt-4" />
                        <Box className="d-flex justify-content-end gap-3 align-items-center mt-4">
                            <Box className="d-flex gap-3">
                                <Button variant="text">Last saved at 08:30pm</Button>
                                <Button variant="secondary">Save</Button>
                            </Box>
                        </Box>
                    </>
                )}
            </Box>

            <Dialog open={isSummaryOpen} onClose={handleCloseSummary} fullWidth maxWidth="sm">
                <DialogTitle>Evaluation summary</DialogTitle>
                <DialogContent sx={{ pt: 1 }}>
                    <Box display="flex" justifyContent="space-between" mb={1.5}>
                        <Box>
                            <Typography fontWeight={600}>{sectionASummary.label}</Typography>
                            <Typography variant="body2" color="text.secondary">
                                {sectionASummary.description}
                            </Typography>
                        </Box>
                        <Typography fontWeight={600}>
                            {sectionASummary.obtained}/{sectionASummary.max}
                        </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between" mb={1.5}>
                        <Box>
                            <Typography fontWeight={600}>{sectionBSummary.label}</Typography>
                            <Typography variant="body2" color="text.secondary">
                                {sectionBSummary.description}
                            </Typography>
                        </Box>
                        <Typography fontWeight={600}>
                            {sectionBSummary.obtained}/{sectionBSummary.max}
                        </Typography>
                    </Box>
                    <Divider sx={{ my: 2 }} />
                    <Box display="flex" justifyContent="space-between" mb={2}>
                        <Typography fontWeight={600}>Total</Typography>
                        <Typography fontWeight={600}>
                            {totalObtained}/{totalMax}
                        </Typography>
                    </Box>
                    {missingSections.length > 0 && (
                        <Box sx={{ background: '#F3F4F8', borderRadius: 2, p: 2 }}>
                            <Box display="flex" alignItems="center" gap={1} mb={1}>
                                <ErrorOutlineIcon color="warning" fontSize="small" />
                                <Typography fontWeight={600}>Attention!</Typography>
                            </Box>
                            <Typography variant="body2" color="text.secondary">
                                Please verify the marks entered against each section before you save.
                            </Typography>
                            <Typography variant="body2" color="text.secondary" mt={1}>
                                No marks entered for the following questions.
                            </Typography>
                            {missingSections.map((item) => (
                                <Typography key={item} variant="body2" color="text.secondary">
                                    {item}
                                </Typography>
                            ))}
                        </Box>
                    )}
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 3 }}>
                    <Button variant="text" onClick={() => handleSave("save")} sx={{ mr: 1 }}>
                        Save
                    </Button>
                    <Button variant="secondary" onClick={() => handleSave("submit")}>
                        Save & Next
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default EvaluationDetails;

